import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SafeHarborPlans } from "client/app/domains/SafeHarborPlans";
import { SafeHarborService } from "../service/safeHarbor.service";
import { formatDate } from "@angular/common";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-select",
  templateUrl: "./select.component.html",
  styleUrls: ["../../../shared/styles/aa.less"],
  standalone: false
})
export class SelectComponent implements OnInit {
  selectSafeharborsForm: UntypedFormGroup;
  submitted = false;
  selectedSubgroupsList: SafeHarborPlans[] = [];
  @Output() selectedSH = new EventEmitter<SafeHarborPlans[]>();
  @Output() selectedEffectiveDate = new EventEmitter<string>();
  @Output() selectedReleaseDate = new EventEmitter<string>();

  effectiveDate: Date = null;
  releaseDate: Date = null;
  maxDate: Date;
  selectedSubGrpListCnt = true;
  showNotValidReleaseDate = false;
  showNotValidEffectiveDate = false;
  masterSubgroupList: SafeHarborPlans[] = [];
  availableSubgroupsList: SafeHarborPlans[];
  filteredAvailableSubgroupsList: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private safeHarborService: SafeHarborService,
    private formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.maxDate = new Date();
    this.submitted = false;

    this.selectSafeharborsForm = this.formBuilder.group({
      shEffectiveDate: ["", Validators.required],
      shRelDate: ["", Validators.required],
    });

    this.safeHarborService.loadSafeHarborPlans().subscribe((data: any) => {
      this.availableSubgroupsList = data;

      for (let i = 0; i < this.availableSubgroupsList.length; i++) {
        this.masterSubgroupList.push(this.availableSubgroupsList[i]);
      }

      this.filteredAvailableSubgroupsList = this.availableSubgroupsList.reduce((accum, item) => {
        accum.push(item.CoopName);
        return accum;
      }, []);
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.selectSafeharborsForm.controls;
  }

  get submitNext() {
    return (
      this.selectedSubgroupsList.length !== 0 &&
      this.effectiveDate != null &&
      this.effectiveDate != undefined &&
      this.releaseDate != null &&
      this.releaseDate != undefined
    );
  }

  navigateToStep2() {
    this.submitted = true;
    this.selectedSubGrpListCnt =
      this.selectedSubgroupsList.length > 0 ? true : false;

    if (
      this.selectSafeharborsForm.invalid ||
      !this.selectedSubGrpListCnt ||
      this.showNotValidEffectiveDate ||
      this.showNotValidReleaseDate
    ) {
      return;
    }

    var selectedSafeHarbors: SafeHarborPlans[] = [];
    for (var o = 0; o < this.selectedSubgroupsList.length; o++) {
      for (var i = 0; i < this.masterSubgroupList.length; i++) {
        if (
          this.masterSubgroupList[i].CoopName.includes(
            this.selectedSubgroupsList[o].toString()
          )
        ) {
          let document: SafeHarborPlans = {
            CoopName: this.masterSubgroupList[i].CoopName,
            DocumentId: this.masterSubgroupList[i].DocumentId,
            SubgroupId: this.masterSubgroupList[i].SubgroupId,
          };
          selectedSafeHarbors.push(document);
        }
      }
    }
    this.selectedSH.emit(selectedSafeHarbors);
    this.selectedEffectiveDate.emit(
      formatDate(this.effectiveDate, "yyyy-MM-dd", "en-US")
    );
    this.selectedReleaseDate.emit(
      formatDate(this.releaseDate, "yyyy-MM-dd", "en-US")
    );
  }

  outPutSelections() {
    this.availableSubgroupsList = [];
    for (let i = 0; i < this.masterSubgroupList.length; i++) {
      this.availableSubgroupsList.push(this.masterSubgroupList[i]);
    }

    for (let x = 0; x < this.selectedSubgroupsList.length; x++) {
      for (let i = 0; i < this.availableSubgroupsList.length; i++) {
        if (
          this.availableSubgroupsList[i].CoopName ==
          this.selectedSubgroupsList[x].CoopName
        ) {
          this.availableSubgroupsList.splice(i, 1);
        }
      }
    }
    this.selectedSubGrpListCnt =
      this.selectedSubgroupsList.length > 0 ? true : false;
  }

  outPutRemovals() {
    this.availableSubgroupsList = [];
    for (let i = 0; i < this.masterSubgroupList.length; i++) {
      this.availableSubgroupsList.push(this.masterSubgroupList[i]);
    }

    for (let x = 0; x < this.selectedSubgroupsList.length; x++) {
      for (let i = 0; i < this.availableSubgroupsList.length; i++) {
        if (
          this.availableSubgroupsList[i].CoopName ==
          this.selectedSubgroupsList[x].CoopName
        ) {
          this.availableSubgroupsList.splice(i, 1);
        }
      }
    }
    this.selectedSubGrpListCnt =
      this.selectedSubgroupsList.length > 0 ? true : false;
  }

  addSlash(event) {
    if (
      event.code != "Backspace" &&
      (event.srcElement.value.length == 2 || event.srcElement.value.length == 5)
    ) {
      event.srcElement.value += "/";
    }
  }

  onlyNumbers(event) {
    if (
      event.code == "Backspace" ||
      event.code == "ArrowLeft" ||
      event.code == "ArrowRight"
    ) {
      return true;
    }
    if (event.srcElement.value.length < 10) {
      if (
        (event.keyCode >= 48 && event.keyCode <= 57) ||
        (event.keyCode >= 96 && event.keyCode <= 105)
      )
        return true;
      else return false;
    } else return;
  }

  updateValueOnSelect(event, controlName) {
    if (this.effectiveDate.toString().length < 10) {
      return;
    }

    var minimumDate = new Date(formatDate(this.maxDate, "MM/dd/yyyy", "en-US"));
    var minDate = new Date(
      new Date(
        minimumDate.getFullYear(),
        minimumDate.getMonth(),
        minimumDate.getDate(),
        0,
        0,
        0,
        0
      ).toString()
    );

    switch (controlName) {
      case "EffectiveDate":
        var effDate = new Date(this.effectiveDate).toString();
        this.showNotValidEffectiveDate =
          new Date(effDate) < new Date(minDate) ? true : false;

        break;
      case "ReleaseDate":
        var relDate = new Date(this.releaseDate).toString();
        this.showNotValidReleaseDate =
          new Date(relDate) < new Date(minDate) ? true : false;
        break;
      default:
        break;
    }
  }

  updateValueOnInput(event, controlName) {
    if (event.srcElement.value.length < 10) {
      return;
    }

    var minimumDate = new Date(formatDate(this.maxDate, "MM/dd/yyyy", "en-US"));
    var minDate = new Date(
      new Date(
        minimumDate.getFullYear(),
        minimumDate.getMonth(),
        minimumDate.getDate(),
        0,
        0,
        0,
        0
      ).toString()
    );

    switch (controlName) {
      case "EffectiveDate":
        this.effectiveDate = event.srcElement.value;
        var effDate = new Date(this.effectiveDate).toString();

        this.showNotValidEffectiveDate =
          new Date(effDate) < new Date(minDate) ? true : false;

        break;
      case "ReleaseDate":
        this.releaseDate = event.srcElement.value;

        var relDate = new Date(this.releaseDate).toString();
        this.showNotValidReleaseDate =
          new Date(relDate) < new Date(minDate) ? true : false;
        break;
      default:
        break;
    }
  }

  clearModalValues(event, controlName) {
    switch (controlName) {
      case "EffectiveDate":
        this.showNotValidEffectiveDate = false;
        break;
      case "ReleaseDate":
        this.showNotValidReleaseDate = false;
        break;
      default:
        break;
    }
  }
}
